export type LocalStorageValue = string | number | boolean | object | null

export const localStorage = {
  getItem: <T>(key: string): T | null => {
    const value = window.localStorage.getItem(key)
    if (value === null) return null
    try {
      return JSON.parse(value)
    } catch {
      return value as T
    }
  },
  setItem: (key: string, value: any) => window.localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value)),
  removeItem: (key: string) => window.localStorage.removeItem(key),
  clear: () => window.localStorage.clear(),
}
